import styled from 'styled-components';

import Button from '../Button';

const StyledSignUp = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PhoneNumberLabel = styled.div`
  margin-left: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.gray.main};
`;

const StyledButton = styled(Button)`
  && {
    margin: ${({ theme }) => theme.spacing(2)};
  }
`;

const TermsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const TermsLink = styled.a`
  color: ${({ theme }) => theme.palette.darkPrimary.main};
  font-weight: bold;
  :hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.darkPrimary.light};
  }
`;

export { StyledSignUp,
  Container,
  PhoneNumberLabel,
  StyledButton,
  TermsContainer,
  TermsLink };
